export default "__VITE_ASSET__BeKMmUV3__"